import React from 'react'
import Font from '@cred/react-font'
import { Testable } from '@cred/react-testable'
import styles from './styles.scss'

const Disclosures = () => {
  const dateToday = new Date(),
    dateTodayFormatted = `${
      dateToday.getMonth() + 1
    }/${dateToday.getDate()}/${dateToday.getFullYear()}`

  return (
    <div className={styles.disclosureContainer}>
      <Testable className={styles.disclosure} testId="disclosure-content">
        <Font weight="bold" color="lighter" className="mb-8">
          General Information and Rate Disclosures:
        </Font>

        <Font type="bodySmall" color="lighter" className="mb-16">
          The listings that appear on this page are from companies from which
          Credible receives compensation. This table does not include all
          companies or all available products. Displayed information is valid as
          of {dateTodayFormatted} and is based on the assumptions, such as
          credit score, loan amount, location, etc., listed at the top of this
          page. Rates, payments, and all information displayed are for
          informational purposes only and are subject to change without notice.
          This is not a credit decision or commitment to lend. Mortgage rates
          and terms you may qualify for depend on your individual financial
          circumstances.
        </Font>

        <Font weight="bold" color="lighter" className="mb-8">
          Payment Disclosures:
        </Font>
        <Font type="bodySmall" color="lighter" className="mb-16">
          All monthly payment amounts above assume on time monthly payments each
          month for the full duration of the loan term (e.g. 360 monthly
          payments for a 30 year loan). Displayed monthly payment amounts do not
          include amounts for property taxes and hazard insurance. Your actual
          monthly payment obligation will be higher. Amounts for borrower-paid
          mortgage insurance premiums are included in the monthly payment amount
          for loan amounts below thresholds set by Fannie Mae and Freddie Mac
          ("conforming thresholds") where the loan to home value ratio is higher
          than 80%, but excluded for loan amounts greater than those thresholds
          or where the loan to home value ratio is equal to or lower than 80%.
          Your actual payment obligation may be higher. Conforming thresholds
          depend on the county where the property is located.
        </Font>

        <Font weight="bold" color="lighter" className="mb-8">
          Fees Disclosures:
        </Font>

        <Font type="bodySmall" color="lighter" className="mb-16">
          The fee amounts shown above include estimates of loan costs and
          closing costs you may pay in connection with a mortgage transaction
          with the assumptions above. This includes fees the lender charges,
          including points and underwriting fees, and third party services the
          lender does not let you shop for such as a flood certification fee. It
          does not include title charges, recording costs, prepaids, initial
          escrow deposit, and other fees.
        </Font>

        <Font type="bodySmall" color="lighter" weight="semiBold">
          Displayed rates are available through Credible Operations, Inc., NMLS
          #1681276
        </Font>
      </Testable>
    </div>
  )
}

export default Disclosures
